import { createManager } from '@vue-youtube/core'

/**
 * Registers the @vue-youtube manager so `usePlayer()` can resolve it. `deferLoading` keeps `install()`
 * from touching `document`/`window` during SSR; the YouTube IFrame API is inserted on the client the
 * first time a player mounts (`autoLoad`).
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(createManager({ deferLoading: { enabled: true, autoLoad: true } }))
})
